import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const RelatedServices = ({ services }) => {
  return (
    <div className="bg-white rounded-xl shadow-elevation-2 p-8 border border-border">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-text-primary mb-2">
          Related Services
        </h2>
        <p className="text-text-secondary">
          Complete your cleaning needs with our complementary services
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services?.map((service, index) => (
          <div
            key={index}
            className="group bg-surface rounded-lg border border-border overflow-hidden hover:shadow-elevation-3 transition-all duration-300"
          >
            <div className="relative h-48 overflow-hidden">
              <Image
                src={service?.image}
                alt={service?.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              
              {/* Service Badge */}
              <div className="absolute top-4 left-4">
                <span className="bg-white/90 text-text-primary px-3 py-1 rounded-full text-sm font-medium">
                  {service?.category}
                </span>
              </div>
              
              {/* Popular Badge */}
              {service?.isPopular && (
                <div className="absolute top-4 right-4">
                  <span className="bg-primary text-white px-3 py-1 rounded-full text-sm font-medium flex items-center space-x-1">
                    <Icon name="Star" size={12} />
                    <span>Popular</span>
                  </span>
                </div>
              )}
            </div>
            
            <div className="p-6">
              <h3 className="text-lg font-semibold text-text-primary mb-2 group-hover:text-primary transition-colors duration-200">
                {service?.title}
              </h3>
              
              <p className="text-text-secondary text-sm mb-4 line-clamp-2">
                {service?.description}
              </p>
              
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-4 text-sm text-text-secondary">
                  <div className="flex items-center space-x-1">
                    <Icon name="Clock" size={14} />
                    <span>{service?.duration}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <Icon name="DollarSign" size={14} />
                    <span>From ${service?.startingPrice}</span>
                  </div>
                </div>
              </div>
              
              <div className="flex items-center space-x-2 mb-4">
                <div className="flex">
                  {[...Array(5)]?.map((_, i) => (
                    <Icon
                      key={i}
                      name="Star"
                      size={14}
                      color={i < service?.rating ? "var(--color-warning)" : "var(--color-border)"}
                    />
                  ))}
                </div>
                <span className="text-sm text-text-secondary">
                  {service?.rating} ({service?.reviewCount} reviews)
                </span>
              </div>
              
              <div className="flex space-x-2">
                <Button
                  variant="default"
                  size="sm"
                  className="flex-1"
                  iconName="Calendar"
                  iconPosition="left"
                >
                  Book Now
                </Button>
                <Link to="/service-details">
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="ArrowRight"
                    iconPosition="right"
                  >
                    Details
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* View All Services */}
      <div className="text-center mt-8">
        <Link to="/service-details">
          <Button
            variant="outline"
            iconName="Grid"
            iconPosition="left"
          >
            View All Services
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default RelatedServices;